import type { BaseRecord, DataProvider } from "@refinedev/core";

/**
 * Placeholder data provider.
 * Real CRUD resources will call tRPC; Refine requires a DataProvider today.
 */
function notImplemented(method: string): never {
	throw new Error(
		`dataProvider.${method} は未実装です。リソース追加時に tRPC 連携を実装してください。`,
	);
}

export const dataProvider = {
	getApiUrl: () => "",
	getList: async () => ({ data: [] as BaseRecord[], total: 0 }),
	getOne: async () => notImplemented("getOne"),
	create: async () => notImplemented("create"),
	update: async () => notImplemented("update"),
	deleteOne: async () => notImplemented("deleteOne"),
	getMany: async () => ({ data: [] as BaseRecord[] }),
} as DataProvider;
